export const LS_KEY = "seleccionPaso3";

export const cache = {
  cursosPorNivel: {},
  gradosPorNivel: {},
  competenciasPorCurso: {},
  capacidadesPorCompetencia: {},
  desempenosPorClave: {},
};
